import { ElementType, HTMLAttributes } from "react"
import styled from "@emotion/styled"
import shouldForwardProp from "@styled-system/should-forward-prop"
import ssCss from "@styled-system/css"
import {
  space,
  flexbox,
  color,
  typography,
  layout,
  position,
  border,
  SpaceProps,
  FlexboxProps,
  ColorProps,
  TypographyProps,
  LayoutProps,
  PositionProps,
  BorderProps,
  background,
  BackgroundProps,
} from "styled-system"

type BaseBoxProps = HTMLAttributes<HTMLDivElement> &
  SpaceProps &
  FlexboxProps &
  ColorProps &
  TypographyProps &
  LayoutProps &
  PositionProps &
  BorderProps &
  BackgroundProps

export interface BoxProps extends BaseBoxProps {
  customCss?: any
  as?: ElementType<any>
  ref?: any
  src?: any
  alt?: any
  href?: any
  target?: any
  rel?: any
  autoPlay?: any
  muted?: any
  loop?: any
  key?: any
  controls?: any
  playsInline?: any
  xWebkitAirplay?: any
  x5VideoPlayerFullscreen?: any
  preload?: any
  x5Playsinline?: any
  webkitPlaysinline?: any
  loading?: string
  isStocksComingSoon?: boolean
}

const Box = styled("div", { shouldForwardProp })<BoxProps>`
  box-sizing: border-box;
  margin: 0;
  ${typography}
  ${flexbox}
  ${space}
  ${color}
  ${layout}
  ${position}
  ${border}
  ${background}
  ${({ customCss }) => ssCss(customCss)}
`

export default Box
